"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ideaReducer = ideaReducer;
const dates_1 = require("../dates");
function assertStatus(current, allowed, action) {
    if (!allowed.includes(current)) {
        throw new Error(`Invalid transition: ${action} requires status ${allowed.join(' | ')}, got '${current}'`);
    }
}
function ideaReducer(doc, event) {
    const updated = (0, dates_1.today)();
    switch (event.type) {
        case 'ACTIVATE_IDEA':
            assertStatus(doc.status, ['draft'], 'ACTIVATE_IDEA');
            return { ...doc, status: 'active', updated };
        case 'COMPLETE_IDEA':
            assertStatus(doc.status, ['active'], 'COMPLETE_IDEA');
            return { ...doc, status: 'done', updated };
        case 'CANCEL_IDEA':
            assertStatus(doc.status, ['draft', 'active'], 'CANCEL_IDEA');
            return { ...doc, status: 'cancelled', updated };
        case 'REFINE_IDEA':
            assertStatus(doc.status, ['draft', 'active'], 'REFINE_IDEA');
            return { ...doc, version: doc.version + 1, updated };
        default: {
            const _exhaustive = event;
            throw new Error(`Unknown event type: ${event.type}`);
        }
    }
}
